// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fj-3";
export var downloadButton = "_fj-4";
export var fileContainer = "_fj-9 _fj-7";
export var fileContainerBase = "_fj-7";
export var fileContainerBaseSm = "_fj-a _fj-7";
export var fileContainerFixedHeight = "_fj-8 _fj-7";
export var fileContainerFixedHeightSm = "_fj-c _fj-a _fj-7";
export var fileContainerSm = "_fj-b _fj-a _fj-7";
export var fileInfo = "_fj-5";
export var fileInfoWidthRestricted = "_fj-6";
export var fileType = "_fj-1";
export var fileTypeName = "_fj-2";
export var fileTypeSm = "_fj-d _fj-1";
export var image = "_fj-0";
export var link = "_fj-f";
export var overflowEllipsis = "_fj-e";